module.exports = __webpack_public_path__ + "static/img/agile-projects.38339ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/agile-projects.png
// module id = Y3iI
// module chunks = 0